import auth from '../../../config/app-specific-config/auth';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import * as types from './dsr-gen-ai-actions-types'

// 
export const setNotifyGenAiRoomReady = (p) => {
	return {
		type: types.SET_NOTIFY_GEN_AI_ROOM_READY,
		payload: p
	};
};

export const setGenAiRoomReadyNotification = (p) => {
	return {
		type: types.SET_GEN_AI_ROOM_READY_NOTIFICATION,
		payload: p
	};
};

export const clearGenAiRoomReadyNotification = () => {
	return async (dispatch) => {
		dispatch(setNotifyGenAiRoomReady(""));
		dispatch(setGenAiRoomReadyNotification(""));
	};
}


// Upload Gen AI reference file
export const uploadGenAiRefFileSuccess = (response) => {
	return {
		type: types.CREATE_GEN_AI_ROOM_SUCCESS,
		payload: response.data
	};
};

export const uploadGenAiRefFileFailure = (error) => {
	return {
		type: types.CREATE_GEN_AI_ROOM_FAILURE,
		error
	};
};

export const uploadGenAiRefFileRequest = () => {
	return {
		type: types.CREATE_GEN_AI_ROOM_REQUEST
	};
};

export function uploadGenAiRefFile(genAiRefFile) {	
	return async (dispatch) => {
		dispatch(uploadGenAiRefFileRequest());
		try {
			const url = `/dsr/upload-gen-ai-ref-file`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				genAiRefFile,
				{ headers }
			);

			dispatch(uploadGenAiRefFileSuccess(response));
				
		} catch (error) {
			dispatch(uploadGenAiRefFileFailure(error));
		}
	};
}

// Create DSR with Gen AI
export const createGenAiRoomSuccess = (response) => {
	return {
		type: types.CREATE_GEN_AI_ROOM_SUCCESS,
		payload: response.data
	};
};

export const createGenAiRoomFailure = (error) => {
	return {
		type: types.CREATE_GEN_AI_ROOM_FAILURE,
		error
	};
};

export const createGenAiRoomRequest = () => {
	return {
		type: types.CREATE_GEN_AI_ROOM_REQUEST
	};
};

export function createGenAiRoom(createGenAiRoomMetadata) {	
	return async (dispatch) => {
		dispatch(createGenAiRoomRequest());
		try {
			const url = `/dsr/create-gen-ai-room`;
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(
				url,
				{createGenAiRoomMetadata},
				{ headers }
			);

			if (response.data.data.createdRoomRoute) {
				dispatch(setGenAiRoomReadyNotification({
					dsrTitle: createGenAiRoomMetadata.dsrTitle ? createGenAiRoomMetadata.dsrTitle : "Your AI generated Room",
					redirectUrl: response.data.data.createdRoomRoute
				})) 
			}

			dispatch(createGenAiRoomSuccess(response));
				
		} catch (error) {
			dispatch(createGenAiRoomFailure(error));
		}
	};
}


export const createGenAiRoomReset = () => {
	return {
		type: types.CREATE_GEN_AI_ROOM_RESET
	};
};

export function resetCreateGenAiRoom() {

	return async (dispatch) => {
	
		try {
			dispatch(createGenAiRoomReset());

		} catch (error) {
			dispatch(createGenAiRoomFailure(error));
		}
	};
}